<mat-toolbar
  [color]="(search$ | async) === true ? 'primary' : null"
  [class.mat-toolbar-transparent]="(search$ | async) === false"
>
  <mat-toolbar-row class="spacing--margin-top">
    <mat-checkbox
      (click)="masterToggle(); $event.preventDefault()"
      color="primary"
      [checked]="isAllSelected$ | async"
      [indeterminate]="(hasSelectedField$ | async) && (isAllSelected$ | async) === false"
      class="flex__child--auto"
      data-test="registration-toolbar-masterToggle"
    ></mat-checkbox>
    <app-cropfield-search
      [values]="cropFields$ | async"
      (filtered)="setFilteredCropFields($event)"
      [keys]="['name', 'cropName']"
      class="flex__child--auto"
    ></app-cropfield-search>
    @if (search$ | async) {
      <button
        mat-icon-button
        (click)="closeSearch()"
        class="flex__child--none"
        data-test="registration-closeSearch"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-toolbar-row>
</mat-toolbar>
<agr-notification-empty
  [isEmpty]="
    (selectedCropFields$ | async)?.length === 0 && (unselectedCropFields$ | async)?.length === 0
  "
  [emptyTitle]="((search$ | async) ? 'noCropFieldsSearchTitle' : 'noCropFieldsTitle') | translate"
  [emptyDescription]="
    ((search$ | async) ? 'noCropFieldsSearchDescription' : 'noCropFieldsDescription') | translate
  "
  emptyActionIcon="clear"
  [emptyActionText]="'resetCropFieldSearch' | translate"
  [showEmptyAction]="search$ | async"
  [emptyImage]="false"
  (emptyAction)="closeSearch()"
>
  @for (index of [0, 1]; track index; let isLast = $last) {
    <div>
      <mat-selection-list
        [ngModel]="selectedCropFieldIds"
        [ngClass]="{ 'last-selection-list': isLast }"
        (selectionChange)="changeSelectedCropField($event)"
        data-test="registration-cropfield-list"
      >
        @if (
          (selectedCropFields$ | async).length &&
          !(isLast && !(unselectedCropFields$ | async)?.length)
        ) {
          <strong class="fixedspacing--margin-horizontal-2">
            {{ ['selectedFields', 'unselectedFields'][index] | translate }}
          </strong>
        }
        @for (
          cropField of [selectedCropFields$, unselectedCropFields$][index] | async;
          track trackByFn($index)
        ) {
          <mat-list-option
            [value]="cropField.id"
            [ngClass]="{
              'field-item__container': true,
              'field-item__container--hovered': cropField.id === hoveredFieldId,
            }"
            checkboxPosition="before"
            color="primary"
            data-test="registration-cropfield-item"
          >
            <div class="field-item">
              <div class="field-item__name-col flex__child--auto">
                <h3>
                  {{ cropField.name }}
                </h3>
                <div>{{ cropField.cropName }}</div>
              </div>
              <div class="field-item__hectares flex__child--none">
                <div>{{ 'hectare-abbreviated' | translate }}</div>
                {{ cropField.areaInHectares | agrNumber }}
              </div>
              <div class="field-item__soil-analysis-count flex__child--none">
                <div>{{ 'soilAnalysisCountHeader' | translate }}</div>
                {{
                  cropField?.soilAnalysisIds?.length
                    ? (cropField.soilAnalysisIds.length | agrNumber)
                    : 0
                }}
              </div>
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }
</agr-notification-empty>
